var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackTop),expression:"showBackTop"}],staticClass:"back-to-top",class:{ 'show': _vm.showBackTop },on:{"click":_vm.scrollToTop}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top-content flex flex-x-c flex-y-c"},[_c('div',{staticClass:"arrow"}),_c('div',[_vm._v("返回顶部")])])
}]

export { render, staticRenderFns }